import * as React from 'react';
import {Link} from 'react-router-dom';
import {DeliverablesResultRowBean, UserPropsBean} from '../api/base/api';
import {advAccountApi} from '../views/account/AdvAccountApi';
import './../views/sidebar/style.css';
import TimezoneEnum = UserPropsBean.TimezoneEnum;
import {StorageKey} from './Storage';

export const LIFETIME_ROAS = 'Lifetime ROAS'

export enum UnitTypeEnum {
    currency = '$',
    percent = '%',
    count = ''
}

export enum GroupByNames {
    bundle = 'Bundle',
    day = 'Day',
    dayAndBundle = 'Day & Bundle',
    dayAndCountry = 'Day & Country',
    country = 'Country',
    countryAndBundle = 'Country & Bundle',
    campaignTags = 'Tags',
    campaignTagsBundle = 'Tags & Bundle',
    campaignTagsCountry = 'Country & Tags',
    campaignTagsDay = 'Day & Tags',
    campaignTagsWeek = 'Week & Tags',
    campaignTagsMonth = 'Month & Tags',
    week = 'Week',
    weekAndBundle = 'Week & Bundle',
    weekAndCountry = 'Week & Country',
    skanCid = 'SKAN CID',
    targetingParam = 'Targeting Parameter',
    month = 'Month',
    monthAndBundle = 'Month & Bundle',
    monthAndCountry = 'Month & Country'
}

export enum ColumnNamesEnum {
    bundle = 'Bundle',
    bundleName = 'Bundle Name',
    creativeTemplate = 'Creative Template',
    dayGroup = 'Day',
    type = 'Type',
    creativeTag = 'Tag',
    country = 'Country',
    impr = 'Impressions',
    click = 'Clicks',
    install = 'Installs',
    conversions = 'Conversions',
    reInstall = 'Re-Install',
    reEngagementInstall = 'Reattributions',
    activeUsers = 'Active Users',
    ctr = 'CTR%',
    installRate = 'CVR%',
    cvr = 'CVR%',
    mediaCost = 'Media Cost',
    spend = 'Spend',
    spendOverall = 'Overall Spend',
    revenue = 'Revenue',
    roiLift = 'ROI Lift',
    cpi = 'CPI',
    cpc = 'CPC',
    ipm = 'IPM',
    cpm = 'CPM',
    rpm = 'RPM',
    cpr = 'CPR',
    revenueCohort = 'Revenue (Cohort)',
    revEvents = 'Rev. Events',
    ftdCostOverall = 'Overall $FTD',
    ftdCost = 'FTD Cost',
    ftdCvr = 'FTD CVR',
    ftdCostCohort = 'FTD Cost (Cohort)',
    ftdUsers = 'FTD Count',
    roas = 'ROAS',
    firstPurchase = 'First Purchase',
    campaignTags = 'Tags',
    arpu = 'ARPU',
    arppu = 'ARPPU',
    skanCid = 'SKAN CID',
    skanTargeting = 'Targeting',
    skanTargetingParam = 'Targeting Parameter',
    day = 'Date',
    week = 'Week',
    month = 'Month'
}

export function dateComparator(date1?: string, date2?: string) {
    let d1 = Date.parse(date1 ? date1 : '');
    let d2 = Date.parse(date2 ? date2 : '');
    if (d1 == d2) {
        return 0;
    }
    return d1 < d2 ? -1 : 1;
}

export function bundleComparator(param1?: string, param2?: string) {
    let p1 = param1 ? param1 : '';
    let p2 = param2 ? param2 : '';

    if (p1.length == 0) {
        return p2.length == 0 ? 0 : 1;
    } else if (p2.length == 0) {
        return -1;
    } else {
        return p1.localeCompare(p2);
    }
}

export function menuItem(path: string, title: any, icon?: string) {
    return path ? (
        <Link className="menu-item" to={`/${path}`}>
            <img src={'/images/' + icon} alt=""/>
            <span className="menu-item">
                {title}
            </span>
        </Link>
    ) : (
        <span className="menu-item">
                <img src={'/images/' + icon} alt=""/>
                <span className="menu-item">
                    {title}
                </span>
            </span>
    );
}

export function sorterFunc(getData: Function, invert: boolean) {
    return (a, b) => {
        let dataA: any = getData(a);
        let dataB: any = getData(b);

        if (dataA == undefined || dataA == null) {
            if (dataB == undefined || dataB == null) {
                return 0;
            } else {
                return invert ? 1 : -1;
            }
        } else if (dataB == undefined || dataB == null) {
            return invert ? -1 : 1;
        } else {
            if (typeof dataA == 'string') {
                dataA = dataA.toUpperCase();
                dataB = dataB.toUpperCase();
            }

            if (dataA < dataB) {
                return invert ? 1 : -1;
            } else if (dataA > dataB) {
                return invert ? -1 : 1;
            } else {
                return 0;
            }
        }
    };
}

export function setLoggedUserProps(setUser: Function) {
    const advertiserIdStr = localStorage.getItem(StorageKey.AdvertiserId)
    const advertiserId = advertiserIdStr ? +advertiserIdStr : undefined
    return advAccountApi.getUserData(advertiserId).then((item: UserPropsBean) => {
        if (item) {
            setUser(
                item.name,
                item.logo,
                item.campaignTypes && item.campaignTypes.length > 1,
                item.advReportType ? item.advReportType : UserPropsBean.CampaignTypesEnum.Ua,
                item.bundleToChannel,
                item.timezone,
                item.timezoneisDst,
                item.advViewOnly,
                item.bundlesWithTags,
                item.haveAudiencesWithControlGroup,
                item.showActualSpend,
                item.campaignTags,
                item.bundles,
                false,
                item.haveIosBundle,
                item.allowDataUpload,
                advertiserId,
                item.funnel,
                item.currency,
                item.showIntegrationsPage,
                item.adMarkupType,
                item.showCpcAndCpm
            );
        }

        return item;
    });
}

export function getTimezoneByTimezoneEnum(value: TimezoneEnum) {
    switch (value) {
        case UserPropsBean.TimezoneEnum.JST:
            return 'Asia/Tokyo';
        case UserPropsBean.TimezoneEnum.KST:
            return 'Asia/Seoul';
        case UserPropsBean.TimezoneEnum.EST:
            return 'America/New_York';
        case UserPropsBean.TimezoneEnum.CET:
            return 'Europe/Paris';
        case UserPropsBean.TimezoneEnum.CST:
            return 'Asia/Shanghai';
        case UserPropsBean.TimezoneEnum.IST:
            return 'Asia/Kolkata';
        case UserPropsBean.TimezoneEnum.UTC:
        default:
            return 'UTC';
    }
}

export function getTimezoneNameByTimezoneEnum(value: TimezoneEnum, timezoneToDst: any) {
    var dstTimezone: boolean = timezoneToDst && timezoneToDst[value];

    switch (value) {
        case UserPropsBean.TimezoneEnum.EST:
            return dstTimezone ? 'EDT' : 'EST';
        case UserPropsBean.TimezoneEnum.CET:
            return dstTimezone ? 'CEST' : 'CET';
        default:
            return value;
    }
}

export function getTimezoneHoursOffsetAndNameByTimezoneEnum(value: TimezoneEnum, timezoneToDst: any) {
    var dstTimezone: boolean = timezoneToDst && timezoneToDst[value];

    switch (value) {
        case UserPropsBean.TimezoneEnum.JST:
            return ' (UTC +9) Japan Standard Time';
        case UserPropsBean.TimezoneEnum.KST:
            return ' (UTC +9) Korea Standard Time';
        case UserPropsBean.TimezoneEnum.CST:
            return ' (UTC +8) China Standard Time';
        case UserPropsBean.TimezoneEnum.EST:
            return dstTimezone ? ' (UTC -4) Eastern Daylight Time' : ' (UTC -5) Eastern Standard Time';
        case UserPropsBean.TimezoneEnum.CET:
            return dstTimezone ? ' (UTC +2) Central European Summer Time' : ' (UTC +1) Central European Time';
        case UserPropsBean.TimezoneEnum.IST:
            return ' (UTC +5:30) India Standard Time';
        case UserPropsBean.TimezoneEnum.UTC:
        default:
            return 'UTC';
    }
}

export function exportToCsv(filename: string, rows: object[]) {
    if (!rows || !rows.length) {
        return;
    }
    const separator = ',';
    const keys = Object.keys(rows[0]);
    const csvContent =
        '\uFEFF' + keys.join(separator) +
        '\n' +
        rows.map(row => {
            return keys.map(k => {
                let cell = row[k] === null || row[k] === undefined ? '' : row[k];
                cell = typeof cell === 'string'
                    ? '"' + cell + '"'
                    : cell;
                return cell;
            }).join(separator);
        }).join('\n');

    const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
    } else {
        const link = document.createElement('a');
        if (link.download !== undefined) {
            // Browsers that support HTML5 download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}

export function getFont(i18n) {
    switch (i18n.language) {
        case 'ru':
        case 'ru-RU':
            return {fontFamily: 'Ubuntu, sans-serif'};
        case 'ja':
        case 'ja-JP':
            return {fontFamily: 'Noto Sans JP, sans-serif'};
        case 'ko':
        case 'ko-KR':
            return {fontFamily: 'Noto Sans KR, sans-serif'};
        case 'zh':
        case 'zh-CN':
            return {fontFamily: 'Noto Sans SC, sans-serif'};
        case 'en':
        case 'en-US':
        default:
            return {fontFamily: 'Maven Pro, sans-serif'};
    }
}

export const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];


export function getAppEventValue(record: DeliverablesResultRowBean, header: string) {
    let appEvents = record.appEvents ? record.appEvents : {}
    return appEvents[header]
}

export function getTimeRangeInDays (startDate: string, endDate: string): number {
    const start = new Date(startDate)
    const end = new Date(endDate)
    const diffInTime = end.getTime() - start.getTime()
    const diffInDays = Math.round(diffInTime / 1000 / 60 / 60 / 24) 
    
    return diffInDays
}

export function getSorting(field: string, isAsc: boolean) {
    if (field.startsWith('appEvent_')) {
        field = field.replace('appEvent_', '')
    }
    if (field.startsWith('dynamicColumn_')) {
        field = field.replace('dynamicColumn_', '')
    }
    return `${field},${isAsc ? 'ASC' : 'DESC'}`
}

export function currencyToSign(currency?: UserPropsBean.CurrencyEnum) {
  switch (currency) {
    case UserPropsBean.CurrencyEnum.JPY:
      return '¥'
    
    default:
      return '$'
  }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/util/Util.tsx